angular.module('config')
.constant('apiConfig', {
	// Enable global mocks
	useMocks: false,
	// Global mocks
	mocks: {
		// For verify-code
		verify_access_code: {
			url:''
		}
	},
	// Api paths
	api: {
		// For verify-code
		verify_access_code: {
			url:'verify_access_code'
		}
	}
});
